import { store } from '../../../store/store';
import { selectInstitution, selectPurchases, } from '../../../store/features/system';
import { GrowthBookFeatures, hasGrowthBookFeature } from '../index';
export const isLocationsAvailable = () => {
    const state = store.getState();
    const institution = selectInstitution(state);
    const purchases = institution && institution.purchases?.length > 0
        ? institution.purchases
        : selectPurchases(state);
    const isEnterpriseClinic = purchases[0]?.seats >= 50;
    const isLocationsEnabled = hasGrowthBookFeature(GrowthBookFeatures.Locations);
    return isEnterpriseClinic || isLocationsEnabled;
};
